var $ = require('jquery');

export default function () {
    $(document).off('click', '.zoom-in-chart.modal-action', zoomInChartClick);
    $(document).on('click', '.zoom-in-chart.modal-action', zoomInChartClick);

    $(document).off('click', '.zoom-in-chart.modal-action.active', zoomOutChartClick);
    $(document).on('click', '.zoom-in-chart.modal-action.active', zoomOutChartClick);

    $('#fullscreenModal').off('hidden.bs.modal', fullscreenModalClosed);
    $('#fullscreenModal').on('hidden.bs.modal', fullscreenModalClosed);
}

function zoomInChartClick (e) {
    e.preventDefault();
    $('#fullscreenModal .modal-dialog .modal-content').remove();
    toggleClasses($(this));
}

function zoomOutChartClick (e) {
    e.preventDefault();
    var zoomButton = $('.zoom-in-chart.modal-action.active');
    toggleClasses(zoomButton);
}

function fullscreenModalClosed () {
    var zoomButton = $('.zoom-in-chart.modal-action.active');
    toggleClasses(zoomButton);
}

function toggleClasses(zoomButton) {
    anim(zoomButton);
    setTimeout(function(){
        zoomButton.toggleClass('active');
        if(zoomButton.hasClass('active')) {
            zoomButton.html('<i class="material-icons">clear</i>');
        } else {
            zoomButton.html('<i class="material-icons">zoom_out_map</i>');
        }
    },300);
}

function anim(zoomButton) {

    zoomButton.parent().toggleClass('scale');

    setTimeout(function(){
        zoomButton.parent().toggleClass('zoomed-chart');
        zoomButton.parent().toggleClass('scale');
    },250);
}


// WEBPACK FOOTER //
// ./App/components/modules/modalForChartDetail.js